import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class PlacesService {
  static getplaceList(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getplace}?id=${item?.id}`
      }
      else
      if(item?.name){
        api= `${API_BASE_URL}${API_PATHS.getplace}?name=${item?.name}&limit=${item?.limit}&page=${item?.page}`;
     } else{
      api = `${API_BASE_URL}${API_PATHS.getplace}?limit=${item?.limit}&page=${item?.page}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addPlace(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addplace}`;
    return axiosInstance
        .post(api,item)
        
}
static editPlace(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editplace}`;
    return axiosInstance
        .put(api,item)
        
}
static deletePlace(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteplace}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deleteplace}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default PlacesService;